import { INote } from './note';

export interface IState {
  completed: boolean;
  failed: boolean;
  processing: boolean;
  notes: INote[];
  note: INote | null;
  isCreating: boolean;
  triggerSaveApiInDoc: boolean;
  payloadForUMCPostDocSave: { nodeId: string; sectionId: string } | null;
  currentSelectedAIUMCNotes: INote[];
}
